import Vue from 'vue'
import App from './App.vue'

import './maps.js'
import './style.scss'
import './favicon.ico'


require.context('./assets', false, /\.(jpe?g|png|gif|svg|png)$/i);
require.context('./products', false, /\.jpe?g$/i);

new Vue({
  el: '#app',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js